import { Controller } from "stimulus";

export default class extends Controller {
  async getTranslatedWords(words = []) {
    const result = await Weglot.translate({
      words: words.map((w) => ({ t: 1, w })),
      languageTo: Weglot.getCurrentLang(),
    });
    return result;
  }

  async confirmAction(event) {
    const link = event.currentTarget;

    if (link.dataset.swalConfirmed === "true") {
      delete link.dataset.swalConfirmed;
      return;
    }

    event.stopPropagation();
    event.preventDefault();

    let title = link.dataset.swalTitle || "Are you sure?";
    let text = link.dataset.swalText || "";
    let confirmButton = link.dataset.swalConfirm || "Yes";
    let cancelButton = "Cancel";

    try {
      const translatedWords = await this.getTranslatedWords([title, text, confirmButton, cancelButton]);

      if (translatedWords.length === 4) {
        [title, text, confirmButton, cancelButton] = translatedWords;
      }

      swal({
        title: title,
        text: text,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: confirmButton,
        allowOutsideClick: true,
        cancelButtonText: cancelButton,
        confirmButtonClass: (link.dataset.swalConfirmClass || "btn btn-lg btn-primary") + " waves-effect waves-light m-t-20",
        cancelButtonClass: "btn btn-lg btn-transparent waves-effect waves-light m-l-10 m-t-20",
        buttonsStyling: false,
      }).then(
        function () {
          link.dataset.swalConfirmed = "true";
          link.click();
        },
        function (dismiss) {
          if (dismiss === "cancel") {
            // no-op
          }
        }
      );
    } catch (error) {}
  }
}
